module.exports = __webpack_public_path__ + "fonts/montserrat-light-webfont.a11330db59d1e0d7b0935e86754b86be.eot?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/montserrat-light-webfont.eot
// module id = 254
// module chunks = 9